import React, { PureComponent } from 'react';
import Masonry from 'masonry-layout';
import Loader from '4all-ui/components/Loader';
import * as styles from './style';
import * as GenericStyles from '../../styles/StyledComponents/GenericList';
import GenericListHeader from '../GenericListHeader';
import VariationItem from '../VariationItem';
import { filterVariationOptions } from '../../helpers/search';

class GenericVariationsList extends PureComponent {
  gridMasonry = '';
  state = {
    searchText: '',
  };

  handleChange = e => {
    this.setState({ searchText: e.target.value }, () => {
      if (this.filterOptions().length) {
        this.initMasonry();
      } else if (!!this.gridMasonry) {
        this.gridMasonry.destroy();
        this.gridMasonry = '';
      }
    });
  };

  filterOptions = () => {
    const { options } = this.props;
    const { searchText } = this.state;

    return filterVariationOptions(searchText, options);
  };

  initMasonry = () => {
    this.gridMasonry = new Masonry('.grid', {
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true,
    });
  };

  toggleItems = () => {
    this.initMasonry();
  };

  componentDidUpdate() {
    this.initMasonry();
  }

  render() {
    const filteredOptions = this.filterOptions();
    const { id, title, desc, searchPlaceholder, isLoading } = this.props;

    return (
      <GenericStyles.Container>
        <styles.Header noVariations={!filteredOptions.length}>
          <GenericListHeader
            id={`${id}-search`}
            title={title}
            desc={desc}
            search
            onChange={this.handleChange}
            searchText={this.state.searchText}
            searchPlaceholder={searchPlaceholder}
            searchInputSize="100%"
          />
        </styles.Header>
        <styles.List className="grid" alignCenter={!filteredOptions.length}>
          {isLoading ? (
            <GenericStyles.LoaderContainer className="loading-variations">
              <Loader size="60px" />
            </GenericStyles.LoaderContainer>
          ) : (
            filteredOptions.map(item => (
              <VariationItem
                className={`grid-item grid-sizer`}
                key={item.id}
                variation={item}
                isOpen={false}
                toggleItems={this.toggleItems}
              />
            ))
          )}

          {!isLoading && !filteredOptions.length && (
            <styles.NoResult>Não há Variações Globais cadastradas.</styles.NoResult>
          )}
        </styles.List>
      </GenericStyles.Container>
    );
  }
}

export default GenericVariationsList;



// WEBPACK FOOTER //
// ./src/components/GenericVariationsList/index.js